import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import Cache from '@aws-amplify/cache';
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form'

export class ProductsEdit extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    myCategoryData: [],
    extID: '',
    name: '',
    description: '',
    category: '',
    stock: '',
    price: '',
    photo: '',
    unit: '',
    unitOptions: ["box", "case", "kg", "item", "piece", "set", "cartons"],
    showPrice: '',
    unitQty: ''
  }

  componentWillMount() {
    this.fetchProductData()
    this.fetchCategoryData();
  }

  handleChange(evt) {
    let value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    if (evt.target.name === 'price' || evt.target.name === 'unitQty') {
      if (isNaN(value)) {
        value = this.state.price
      }
    }
    this.setState({ [evt.target.name]: value });
  }

  fetchCategoryData = async () => {
    axios.get('/categories')
      .then(data => {
        console.log(data);
        this.setState({
          myCategoryData: data
        });
      })
      .catch(err => {
        console.log(err);
        Rollbar.error(err)
        toast.error('Failed to fetch categories')
      })
  }

  fetchProductData = async () => {
    axios.get('/products/' + this.props.match.params.id)
      .then(data => {
        console.log(data);
        this.setState({
          name: data[0].name,
          description: data[0].description,
          category: data[0].categoryID,
          stock: data[0].stock === '1' ? true : false,
          price: data[0].price,
          photo: data[0].photo,
          extID: data[0].extID,
          unit: data[0].unit,
          showPrice: data[0].showPrice,
          unitQty: data[0].unitQty
        });
      })
      .catch(err => {
        console.log(err);
        Rollbar.error(err)
        toast.error('Failed to fetch product details')
      })
  }

  updateProduct = async () => {
    let requestParams = {
      'productID': this.props.match.params.id,
      'name': this.state.name,
      'description': this.state.description,
      'photo': this.state.photo,
      'price': this.state.price,
      'categoryID': this.state.category,
      'stock': this.state.stock,
      'unit': this.state.unit,
      'showPrice': this.state.showPrice,
      'unitQty': this.state.unitQty
    }
    if (this.state.name && this.state.category) {
      axios.post('/products/update', requestParams)
        .then(data => {
          console.log(data);
          toast.success('Updated Product!')
          this.props.history.push("/products")
        })
        .catch(err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to save product changes')
        })
    } else {
      toast.error('All product fields are required')
    }
  }

  uploadImage = e => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      var randomStr = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      let requestParams = {
        'fileName': 'product_' + this.props.user.supplierID + '_' + randomStr + '_' + file.name,
        'fileType': file.type
      }
      axios.post('/user/update/image', requestParams)
        .then(data => {
          console.log(data);
          const options = {
            headers: {
              'Content-Type': file.type,
            }
          };
          axios.defaults.headers.common = {}
          axios.put(data.url, file, options)
            .then(data2 => {
              console.log(data2);
              this.setState({
                photo: data.finalUrl
              });
            })
            .catch(err2 => {
              console.log(err2);
              Rollbar.error(err2)
              toast.error("Error: Could not upload image");
            })
            .then(() => {
              axios.defaults.headers.common = { 'Authorization': 'Bearer ' + Cache.getItem('supplier_auth_token') }
            })
        })
        .catch(err => {
          console.log(err);
          Rollbar.error(err)
          toast.error("Error: Could not get s3 upload url");
        })
    }
  }

  render() {
    return (
      <div className="mar-bot-lg">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
          <h1 className="h3">Edit Product</h1>
        </div>
        <div className="row">
          <div className="col-sm-6 productImg">
            <div className="card">
              <div className="card-header">
                Image
              </div>
              <div className="card-body">
                <div className="form-group productImg">
                  <div className="custom-file mb-2">
                    <input type="file" className="custom-file-input" id="customFile" accept='image/*' onChange={this.uploadImage} />
                    <label className="custom-file-label" htmlFor="customFile">Choose file</label>
                  </div>
                  <div className="preview-img-border">
                    {this.state.photo ? <img src={this.state.photo} alt="product image" /> : <p>Please upload a product image</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-header">
                Information
                {this.state.extID ? <h6 className="float-right mb-0"><span className="badge badge-warning">External</span></h6> : null}
              </div>
              <div className="card-body">
                <form>
                  <div className="form-group">
                    <label>Name:</label>
                    <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Description:</label>
                    <textarea className="form-control" rows="3" name="description" value={this.state.description} onChange={this.handleChange}></textarea>
                  </div>
                  <div className="form-group">
                    <label>Category</label>
                    <select className="form-control" name="category" value={this.state.category} onChange={this.handleChange}>
                      {this.state.myCategoryData.map((data, i) =>
                        <option key={i} value={data.categoryID} >{data.name}</option>
                      )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Stock Level</label>
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      name={'stock'}
                      id={'stock'}
                      label={'Available'}
                      checked={this.state.stock}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <small className="form-text text-muted">
                      If you are using an accounting integration, this value will be updated automatically based on the inventory values present in your accounting system.
                    </small>
                  </div>
                  <div className="form-group">
                    <label>Base Price</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input type="text" className="form-control" name="price" value={this.state.price} onChange={this.handleChange}/>
                    </div>
                    <small className="form-text text-muted">
                      This price can be overwritten using price lists, to control the price for individual/groups of customers. This value will be used when there is no price list associated with a customer.
                    </small>
                  </div>
                  <div className="form-group">
                    <label>Unit</label>
                    <input type="text" className="form-control" list="unitOptions" name="unit" value={this.state.unit} onChange={this.handleChange}/>
                    <datalist id="unitOptions">
                      {this.state.unitOptions.map((data, i) =>
                        <option key={i}>{data}</option>
                      )}
                    </datalist>
                  </div>
                  <div className="form-group">
                    <label>Per Unit Sub Qty</label>
                    <input type="text" className="form-control" name="unitQty" value={this.state.unitQty} onChange={this.handleChange}/>
                    <small className="form-text text-muted">
                      Optional - number of items within the product unit (e.g. if Unit is Box then this value will be the number of items within that box). This value is used to calculate a unit price shown on invoices.
                    </small>
                  </div>
                  <div className="form-group">
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      name={'showPrice'}
                      id={'showPrice'}
                      label={'Show Price'}
                      checked={this.state.showPrice}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <small className="form-text text-muted">
                      Display price to customers when they are ordering. If set to off, then customers will not see the price when ordering (but will see the price once the order has been invoiced). Only disable this if you plan on setting the price for every order.
                    </small>
                  </div>
                </form>
                <button type="button" onClick={this.updateProduct} className="btn btn-success btn-sm btn-block">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
